
import { initSlickCarouselMilestone } from "./../js/slickCarousel/initSlickCarouselMilestone";

initSlickCarouselMilestone("milestone");
